import { ActivatedRoute } from '@angular/router';
import { CreateCampaignService } from './create-campaign.service';
import { Component, Input, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { CreateCampaign } from '../../_shared/models/campaign.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, switchMap, take, takeLast, tap } from 'rxjs';

export interface CreateCampaignForm {
  title: FormControl<string>;
  description: FormControl<string>;
  url: FormControl<string>;
  team: FormControl<string>,
};

@Component({
  standalone: false,
  selector: 'app-create-campaign',
  templateUrl: './create-campaign.component.html',
  styleUrls: ['./create-campaign.component.scss'],
})

export class CreateCampaignComponent {
  private modalController = inject(ModalController);
  private createCampaignService = inject(CreateCampaignService);

  @Input({ required: true }) team: string;

  form = new FormGroup<CreateCampaignForm>({
    title: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required),
    url: new FormControl(null, [Validators.required, Validators.pattern(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/)]),
    team: new FormControl(null, Validators.required),
  })

  submitForm(): void {
    this.form.controls.team.setValue(this.team);
    
    if (this.form.invalid) return;

    this.createCampaignService.create(this.form.value as CreateCampaign)
      .pipe(take(1))
      .subscribe({
        next: (campaign) => this.modalController.dismiss(campaign)
      })
  }

  async dismiss(): Promise<void> {
    this.modalController.dismiss();
  }

}
